import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["profile", "activity", "isOnboarding"],
    _excluded2 = ["activity", "stage", "challenge", "challengeHeaderRef"];

var _templateObject;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { AdminBar, Avatar, ChallengeAncillaryActions, Link, PointsButton, ProgressBar, SkipOnboardingButton, Tooltip } from '@infl-ts/ui-advocate-components';
import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, IconButton, styled, Typography, useMediaQuery } from '@mui/material';
import { pipe } from 'fp-ts/function';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Header = styled(Box)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  background: ", ";\n"])), function (p) {
  return p.theme.palette.common.white;
});

var AvatarButton = function AvatarButton(_ref) {
  var profile = _ref.profile;
  return /*#__PURE__*/_jsx(Link, {
    sx: {
      ml: 1
    },
    href: "/profiles/".concat(profile.id),
    "data-element": "Link",
    "data-component": "AvatarButton",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(Avatar, {
      size: "small",
      member: profile,
      disabledPopover: true,
      "data-element": "Avatar",
      "data-component": "AvatarButton",
      "data-source-file": "index.tsx"
    })
  });
};

export var PointsSummary = function PointsSummary(_ref2) {
  var profile = _ref2.profile;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'inline-flex',
      alignItems: 'center'
    },
    "data-element": "Box",
    "data-component": "PointsSummary",
    "data-source-file": "index.tsx",
    children: [/*#__PURE__*/_jsx(PointsButton, {
      currentPoints: profile.currentPoints,
      "data-element": "PointsButton",
      "data-component": "PointsSummary",
      "data-source-file": "index.tsx"
    }), /*#__PURE__*/_jsx(AvatarButton, {
      profile: profile,
      "data-element": "AvatarButton",
      "data-source-file": "index.tsx"
    })]
  });
};

var Actions = function Actions(_ref3) {
  var onClose = _ref3.onClose,
      challenge = _ref3.challenge,
      stage = _ref3.stage,
      profile = _ref3.profile,
      canClose = _ref3.canClose,
      isOnboarding = _ref3.isOnboarding,
      activityState = _ref3.activityState;
  return /*#__PURE__*/_jsxs(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'row'
    },
    "data-element": "Box",
    "data-component": "Actions",
    "data-source-file": "index.tsx",
    children: [isOnboarding ? null : /*#__PURE__*/_jsx(ChallengeAncillaryActions, {
      challenge: challenge,
      profile: profile,
      onCompleteAction: onClose,
      zIndex: function zIndex(t) {
        return t.zIndex.aboveDrawer;
      },
      hideSaveForLater: activityState === 'closed'
    }), canClose ? isOnboarding ? /*#__PURE__*/_jsx(SkipOnboardingButton, {
      onClose: onClose,
      stage: stage,
      activityState: activityState
    }) : /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsx(Tooltip, {
          title: t('Close'),
          children: /*#__PURE__*/_jsx(IconButton, {
            onClick: onClose,
            children: /*#__PURE__*/_jsx(CloseIcon, {})
          })
        });
      }
    }) : null]
  });
};

export var calculateChallengePercentComplete = function calculateChallengePercentComplete(challenge, stage, activity, totalStages) {
  return !challenge.availableForCompletion ? 100 : stage ? stage.position / totalStages * 100 : activity ? 100 : 0;
};

var PointsAndActions = function PointsAndActions(_ref4) {
  var profile = _ref4.profile,
      activity = _ref4.activity,
      isOnboarding = _ref4.isOnboarding,
      props = _objectWithoutProperties(_ref4, _excluded);

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [!isOnboarding && /*#__PURE__*/_jsx(PointsSummary, {
      profile: profile
    }), /*#__PURE__*/_jsx(Actions, _objectSpread(_objectSpread({}, props), {}, {
      profile: profile,
      activityState: activity === null || activity === void 0 ? void 0 : activity.state,
      isOnboarding: isOnboarding,
      "data-element": "Actions",
      "data-component": "PointsAndActions",
      "data-source-file": "index.tsx"
    }))]
  });
};

var ChallengeHeader = function ChallengeHeader(_ref5) {
  var activity = _ref5.activity,
      stage = _ref5.stage,
      challenge = _ref5.challenge,
      challengeHeaderRef = _ref5.challengeHeaderRef,
      props = _objectWithoutProperties(_ref5, _excluded2);

  return pipe(useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  }), function (isMobile) {
    return /*#__PURE__*/_jsxs(AppBar, {
      ref: challengeHeaderRef,
      sx: {
        boxShadow: 'none',
        zIndex: function zIndex(t) {
          return t.zIndex.abovePopover;
        }
      },
      color: "transparent",
      position: "sticky",
      children: [isMobile ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            position: 'sticky',
            top: 0,
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(AdminBar, {})
        }), /*#__PURE__*/_jsxs(Header, {
          sx: {
            p: 2,
            minHeight: 116,
            flexDirection: 'column'
          },
          children: [/*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between'
            },
            children: /*#__PURE__*/_jsx(PointsAndActions, _objectSpread(_objectSpread({}, props), {}, {
              stage: stage,
              challenge: challenge,
              activity: activity
            }))
          }), /*#__PURE__*/_jsx(Typography, {
            sx: {
              textAlign: 'start',
              mt: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            },
            variant: "h3",
            dangerouslySetInnerHTML: {
              __html: challenge.headline
            }
          })]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Box, {
          sx: {
            position: 'sticky',
            top: 0,
            width: '100%'
          },
          children: /*#__PURE__*/_jsx(AdminBar, {})
        }), /*#__PURE__*/_jsxs(Header, {
          sx: {
            py: 1,
            px: 3,
            height: 64,
            flexDirection: 'row',
            alignItems: 'center'
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "h3",
            dangerouslySetInnerHTML: {
              __html: challenge.headline
            }
          }), /*#__PURE__*/_jsx(Box, {
            sx: {
              display: 'flex',
              alignItems: 'center'
            },
            children: /*#__PURE__*/_jsx(PointsAndActions, _objectSpread(_objectSpread({}, props), {}, {
              stage: stage,
              challenge: challenge,
              activity: activity
            }))
          })]
        })]
      }), pipe(calculateChallengePercentComplete(challenge, stage, activity, challenge.totalStages), function (progressPercent) {
        return /*#__PURE__*/_jsx(ProgressBar, {
          sx: {
            zIndex: '-1'
          } //This element is showing over all the other zindexes
          ,
          color: (activity === null || activity === void 0 ? void 0 : activity.state) !== 'rejected' && progressPercent === 100 && activity && !activity.currentStage ? 'success' : 'primary',
          progress: (activity === null || activity === void 0 ? void 0 : activity.state) === 'rejected' ? 100 : progressPercent
        });
      })]
    });
  });
};

export default ChallengeHeader;